import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiTestsList, apiTestsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/tests/getData', async datas => {
    const { data } = await apiTestsList(datas.id, datas)
    return data
})

export const getView = createAsyncThunk('admin/tests/getView', async id => {
    const { data } = await apiTestsView(id)
    data.test_type.equipment_id = (data.equipments ?? []).map(e => e.equipment_id)
    return data
})

export const testsSlice = createSlice({
    name: 'admin/tests',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 50,
            search: '',
            column: 'position',
            dir: 'asc',
        },
        view: null,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.data = []
                state.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = null
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = testsSlice.actions

export default testsSlice.reducer
